<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-22 14:07:38
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2025-10-13 10:56:00
-->
<template>
  <div class="innovative innovative-accuffrangio" :class="{textj: language != 'en'}" ref="accuffrangio">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffrangio.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accuffrangio.list[0].title')"></div>
      </div>
      <div :class="language == 'en' ? 'p-t-10' : 'p-t-28 p-l-30 p-r-15'">
        <img class="wid100" :src="$t('product.accuffrangio.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.accuffrangio.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="accuffrangio-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.accuffrangio.list[1].title')"></div>
          <div class="accuffrangio-characteristics-box p-r-10">
            <div class="p-t-20 p-b-40" v-for="item, index in $t('product.accuffrangio.list[1].des')" :key="index">
              <div class="p-b-20 textc">
                <img class="accuffrangio-characteristics-img" :src="item.img" alt="" srcset="">
              </div>
              <div class="innovative-wrap-item-title textc fz-30 p-b-25">
                <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
              </div>
              <div v-for="$item, $index in item.list" :key="$index">
                <p class="innovative-characteristics-item" v-html="$item"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accuffrangio-advantages">
      <div>
        <div class="innovative-item-title" v-html="$t('product.accuffrangio.list[2].title')"></div>
        <div class="innovative-accuffrangio-m-h">
          <div class="innovative-accuffrangio-m-h-item" :class="{flex: language != 'en'}" v-for="item, index in $t('product.accuffrangio.list[2].des')" :key="index">
            <div class="p-r-30 textc m-h-item-left" :class="{wid100: language == 'en'}">
              <img class="accuffrangio-characteristics-img" :src="item.img" alt="" srcset="">
              <div class="innovative-wrap-item-title fz-28 p-t-20" v-html="item.title"></div>
            </div>
            <div class="flex_1">
              <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
            </div>
          </div>
          <div class="textc p-b-50">
            <img :style="{'max-width': '80%'}" :src="$t('product.accuffrangio.list[2].img')" alt="" srcset="">
            <p :class="language == 'en' ? 'fontw' : 'color_008CDF'" v-html="$t('product.accuffrangio.list[2].imgDes')"></p>
          </div>
        </div>
      </div>
      <div class="m-t-40">
        <div class="innovative-item-title widauto ilblk p-r-100" v-html="$t('product.accuffrangio.list[3].title')"></div>
        <div class="innovative-accuffrangio-m-h p-t-50 p-b-50">
          <p class="innovative-characteristics-item" v-for="$item, $index in $t('product.accuffrangio.list[3].des')" :key="$index" v-html="$item"></p>
        </div>
      </div>
    </div>
    <!-- <div v-if="language == 'en'" class="accuffrangio-new">
      <div class="innovative-container">
        <div class="innovative-item-title p-l-15 widauto ilblk p-r-100" v-html="$t('product.accuffrangio.list[4].title')"></div>
        <div class="innovative-characteristics">
          <div class="">
            <div class="accuffrangio-new-item">
              <img :src="$t('product.accuffrangio.list[4].des[1].img')" alt="" srcset="">
            </div>
            <template v-for="item, index in $t('product.accuffrangio.list[4].des')">
              <div v-if="index != 1" class="accuffrangio-new-item" :key="index">
                <div class="accuffrangio-new-item-box">
                  <div class="img-box">
                    <img :src="item.img" alt="" srcset="">
                  </div>
                  <div class="textc">
                    <div class="accuffrangio-new-item-title">{{ item.title }}</div>
                  </div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in item.des" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </template>
          </div>
          <div class="accuffrangio-new-sign">
            <p class="innovative-characteristics-item " v-html="$t('product.accuffrangio.list[4].sign')"></p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accuffrangio.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accuffrangio.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accuffrangio {
  .accuffrangio-characteristics {
    background-image: url('~@/assets/images/innovate/AccuFFRangio/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .accuffrangio-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px 8%;
    }
    .accuffrangio-characteristics-img {
      max-height: 80px;
    }
  }
  .accuffrangio-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding: 50px 30px;
  }
  .innovative-accuffrangio-m-h {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
    padding: 0 30px;
    .innovative-accuffrangio-m-h-item {
      padding: 40px 20px;
      .m-h-item-left {
        width: 150px;
      }
      img {
        max-width: 100px;
      }
    }
  }
  .accuffrangio-new {
    padding-top: 20px;
    .innovative-characteristics {
      box-shadow: none;
      background: none;
      padding: 80px 0 0;
    }
    img {
      width: 100%;
    }
    .accuffrangio-new-item {
      padding: 120px 0;
      &:first-child {
        padding: 0 0 200px;
      }
      &:last-child {
        padding: 60px 0 30px;
      }
    }
    .accuffrangio-new-item-title {
      display: inline-block;
      min-width: 508px;
      max-width: 80%;
      height: 61px;
      line-height: 61px;
      background: #48B7EB;
      border-radius: 31px;
      color: #ffffff;
      text-align: center;
      margin-bottom: 40px;
      font-size: 30px;
    }
    .accuffrangio-new-item-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 200px 30px 30px;
      .img-box {
        // height: 300px;
        position: relative;
      }
      img {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
    .accuffrangio-new-sign {
      padding-top: 30px;
      .innovative-characteristics-item {
        font-size: 18px;
        line-height: 24px;
      }
      .innovative-characteristics-item::before {
        content: '*';
        width: auto;
        height: auto;
        border-radius: 0;
        background: transparent;
        top: 2px;
        left: 0;
        font-size: 20px;
        color: #008CDF;
      }
    }
  }
}
</style>
